import React from "react";
import PostList from "../PostList/PostList.js";

const HomeComponent = () => {
    return(
      <>
       <PostList/>
      </>
  );
}
export default HomeComponent;
